import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => (
  <footer className="syukra-footer">
    <div className="syukra-footer__container">
      <div className="syukra-footer__main">
        {/* Help Section */}
        <div className="syukra-footer__section syukra-footer__help">
          <h3 className="syukra-footer__heading">Need Help?</h3>
          <ul className="syukra-footer__contact-list">
            <li>
              <i className="fab fa-whatsapp"></i> Whatsapp Us : +91 85114 82368 &nbsp; &nbsp;
              <br></br>
              <span>Mon–Fri: 10am–6:30pm</span>
            </li>
            <li>
              <i className="fas fa-phone-alt"></i> Call Us : +91 85114 82368 &nbsp; &nbsp;
              <br></br>
              <span>Mon–Fri: 10am–6:30pm</span>
            </li>
            <li>
              <i className="fas fa-envelope"></i> Email Us : syukra.contact@gmail.com &nbsp; &nbsp;
              <br></br>
              <span>Mon–Fri: 10am–6:30pm</span>
            </li>
          </ul>
          <div className="syukra-footer__socials">
            <a href="https://www.instagram.com/syukra.in/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      
        {/* Newsletter Section */}
        <div className="syukra-footer__section syukra-footer__newsletter">
          <h2>Be the first to know about new collections</h2>
          <p>We’ll send you updates on new launches, products and events, only good stuff.</p>
          <a className="syukra-footer__btn" href="https://www.instagram.com/syukra.in/">Follow us on Instagram</a>
        </div>
      </div>
      <div className="syukra-footer__bottom">
        <span>© {new Date().getFullYear()}, Syukra - All rights reserved.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
